import { Copy, MoreHorizontal, Pencil, Star, Trash2 } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import type { SavedQueryItem } from "@/lib/http/editor"

interface QueryActionsDropdownProps {
  query: SavedQueryItem
  onRename: (q: SavedQueryItem) => void
  onDuplicate: (q: SavedQueryItem) => void
  onToggleFavorite: (q: SavedQueryItem) => void
  onDelete: (q: SavedQueryItem) => void
}

export function QueryActionsDropdown({
  query,
  onRename,
  onDuplicate,
  onToggleFavorite,
  onDelete,
}: QueryActionsDropdownProps) {
  const favoriteLabel = query.is_favorite ? "Remove from favorites" : "Add to favorites"

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 opacity-0 transition-opacity hover:bg-gray-200 group-hover:opacity-100 dark:hover:bg-gray-700"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreHorizontal className="h-3.5 w-3.5 text-gray-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem className="text-xs" onClick={() => onRename(query)}>
          <Pencil className="mr-2 h-3.5 w-3.5" />
          Rename
        </DropdownMenuItem>
        <DropdownMenuItem className="text-xs" onClick={() => onDuplicate(query)}>
          <Copy className="mr-2 h-3.5 w-3.5" />
          Duplicate
        </DropdownMenuItem>
        <DropdownMenuItem className="text-xs" onClick={() => onToggleFavorite(query)}>
          <Star className="mr-2 h-3.5 w-3.5" />
          {favoriteLabel}
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="text-xs text-red-600 focus:text-red-600 dark:text-red-400 dark:focus:text-red-400"
          onClick={() => onDelete(query)}
        >
          <Trash2 className="mr-2 h-3.5 w-3.5" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
